import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { AdUnitAlert } from 'features/inventory/ad-unit/types/adUnitAlert'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { AdUnitForTable, AdUnitSortBy } from '../../../types'
import { AdUnitForTableDTO, AdUnitSortByDTO } from './types'

export const adUnitForTableFromDTO = (from: AdUnitForTableDTO) =>
  mapDTO<AdUnitForTableDTO, AdUnitForTable>({ from }).transform(adUnitDTO => ({
    ...adUnitDTO,
    alerts: alertsFromDTO<AdUnitAlert>(adUnitDTO.fieldAlerts),
    divId: adUnitDTO.divId || undefined,
    domain: {
      ...adUnitDTO.domain,
      alerts: alertsFromDTO<DomainAlert>(adUnitDTO.domain.alerts),
    },
    name: adUnitDTO.name || undefined,
    updatedAt: new Date(adUnitDTO.updatedAt),
  }))

export const sortToDTO = (sort: SortInput<AdUnitSortBy>): SortInput<AdUnitSortByDTO> => {
  const { by } = sort

  if (by === 'name') {
    return { ...sort, by: 'adUnitName' }
  } else if (by === 'domain.name') {
    return { ...sort, by: 'domainName' }
  } else {
    return { ...sort, by }
  }
}
